import { ref } from "vue"

const isLanguageModalOpen = ref(false)

export function useLanguageModal() {
    function openLanguageModal() {
        isLanguageModalOpen.value = true
    }

    function closeLanguageModal() {
        isLanguageModalOpen.value = false
    }

    function toggleLanguageModal() {
        isLanguageModalOpen.value = !isLanguageModalOpen.value
    }

    return {
        isLanguageModalOpen,
        openLanguageModal,
        closeLanguageModal,
        toggleLanguageModal,
    }
}
